/* eslint-disable no-prototype-builtins */
/* eslint-disable no-fallthrough */
import * as actions from 'app/actions/map';
import * as notificationActions from 'app/actions/notification';
import http from 'app/services/http';
import { MAP_SET_TRANSPORT_HISTORY_ITEMS_CONDITIONS, SET_HISTORY_SELECTED_TIME, SET_HISTORY_TRACKS_VISIBLE, SET_IS_HISTORY_OPEN, SET_TRANSPORT_HISTORY_TRACKS_ITEMS, SET_TRANSPORT_SELECTED_DATE } from 'app/utils/constants';
import moment from 'moment/moment';

export default function mapReducer(
    state = {
        ref: null,
        zoom: 14,
        bounds: null,
        layerSelected: config.mapLayerDefault,
        geofenceMode: '',
        activeWindow: 'transport',
        transportWindowMinimize: false,
        transportTab: 'condition',
        filterTab: 'transport',
        transportItems: [],
        transportSelectedItem: null,
        transportSelectedDate: [
            moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
            moment()
                .endOf('day')
                .add({
                    hours: 8,
                    seconds: 1,
                    minutes: 1,
                })
                .format('YYYY-MM-DD HH:mm:ss'),
        ],
        transportConditionItems: [],
        transportFilterCheckedType: JSON.parse(localStorage.getItem('transportFilterCheckedType')) ?? 'all',
        transportCheckedItems: JSON.parse(localStorage.getItem('transportCheckedItems')) ?? [],
        transportMarkedCheckedItems: JSON.parse(localStorage.getItem('transportMarkedCheckedItems')) ?? [],
        transportProcessingCheckedItems: JSON.parse(localStorage.getItem('transportProcessingCheckedItems')) ?? [],
        transportSortSelectedItem: JSON.parse(localStorage.getItem('transportSortSelectedItem')) ?? {
            name: config.mapTransportColumns[2].name,
            order: config.mapTransportColumns[2].order,
        },
        transportFilterCheckedItems: JSON.parse(localStorage.getItem('transportFilterCheckedItems')) ?? config.mapTransportFilters.filter((filter) => !filter.hidden).map((filter) => filter.name),
        transportColumnCheckedItems: JSON.parse(localStorage.getItem('transportColumnCheckedItems')) ?? config.mapTransportColumns.filter((filter) => !filter.hidden).map((column) => column.name),
        transportConditionFilterCheckedType: 'all',
        transportConditionFilterCheckedItems: JSON.parse(localStorage.getItem('transportConditionFilterCheckedItems')) ?? config.mapTransportConditionFilters.reduce((accumulator, currentValue) => [...accumulator, ...currentValue.filters], []),
        transportBroadcastSelectedItem: null,
        transportConditionSelectedItem: null,
        transportConditionSelectedDatetime: null,
        transportActivityQueue: [],
        transportConditionQueue: [],
        transportSearchValue: '',
        transportGeofenceView: false,
        geofenceItems: [],
        geofenceUpdatedItem: null,
        geofenceChangedItem: null,
        geofenceUpdatedMode: 'create',
        geofenceCheckedId: [],
        geofenceGroupItems: [],
        geofenceGroupItemsLimit: 60,
        geofenceSearchValue: '',
        taskItems: [],
        taskSelectedItem: null,
        taskSortSelectedItem: { name: config.mapTaskColumns[3].name, order: config.mapTaskColumns[3].order },
        taskFilterCheckedItems: config.mapTaskFilters.map((filter) => filter.name),
        taskColumnCheckedItems: config.mapTaskColumns.map((column) => column.name),
        taskSearchValue: '',
        notificationEvents: [],
        isHistoryOpen: false,
        historySelectedTime: moment(),
        historyConditionsItems: [],
        transportHistoryTracksItems: {},
        historyTracksVisible: false,
    },
    action
) {
    switch (action.type) {
        case SET_TRANSPORT_HISTORY_TRACKS_ITEMS: {
            const { items } = action.payload;
            let transportHistoryTracksItems = {};
            for (let key in items) {
                transportHistoryTracksItems[key] = items[key].map((item) => ({
                    ...item,
                    datetime: moment.utc(item.datetime).local().format('YYYY-MM-DD HH:mm:ss'),
                }));
            }
            return {
                ...state,
                transportHistoryTracksItems,
            };
        }
        case SET_TRANSPORT_SELECTED_DATE: {
            const { value } = action.payload;
            return {
                ...state,
                transportSelectedDate: value,
            };
        }
        case MAP_SET_TRANSPORT_HISTORY_ITEMS_CONDITIONS: {
            const { items } = action.payload;
            return {
                ...state,
                historyConditionsItems: items,
            };
        }
        case SET_HISTORY_SELECTED_TIME: {
            const { value } = action.payload;
            return {
                ...state,
                historySelectedTime: value,
            };
        }
        case SET_IS_HISTORY_OPEN: {
            const { value } = action.payload;
            return {
                ...state,
                isHistoryOpen: value,
                ...(value === true && { historyTracksVisible: false }),
            };
        }
        case SET_HISTORY_TRACKS_VISIBLE: {
            const { value } = action.payload;
            return {
                ...state,
                historyTracksVisible: value,
            };
        }
        case 'MAP_SET_REF': {
            const { ref } = action.payload;

            return {
                ...state,
                ref: ref,
                bounds: ref.current ? ref.current.getBounds() : state.bounds,
            };
        }
        case 'MAP_SET_ZOOM': {
            const { value } = action.payload;

            return {
                ...state,
                zoom: value,
            };
        }
        case 'MAP_SET_BOUNDS': {
            const { zoom, bounds } = action.payload;

            return {
                ...state,
                zoom: zoom,
                bounds: bounds,
            };
        }
        case 'MAP_SET_LAYER_SELECTED': {
            const { value } = action.payload;

            return {
                ...state,
                layerSelected: value,
            };
        }
        case 'MAP_SET_GEOFENCE_MODE': {
            const { value } = action.payload;

            return {
                ...state,
                geofenceMode: value,
            };
        }
        case 'MAP_SET_ACTIVE_WINDOW': {
            const { value } = action.payload;

            return {
                ...state,
                activeWindow: value,
            };
        }
        case 'MAP_SET_TRANSPORT_WINDOW_MINIMIZE': {
            const { flag } = action.payload;

            return {
                ...state,
                transportWindowMinimize: flag,
            };
        }
        case 'MAP_SET_TRANSPORT_GEOFENCE_VIEW': {
            const { flag } = action.payload;

            return {
                ...state,
                transportGeofenceView: flag,
            };
        }
        case 'MAP_SET_TRANSPORT_TAB': {
            const { value } = action.payload;

            return {
                ...state,
                transportTab: value,
                transportSelectedItem: state.transportSelectedItem
                    ? {
                          ...state.transportSelectedItem,
                          conditionOptions: {
                              ...state.transportSelectedItem.conditionOptions,
                              open: false,
                          },
                          parkingPointsOptions: {
                              ...state.transportSelectedItem.parkingPointsOptions,
                              open: false,
                          },
                      }
                    : state.transportSelectedItem,
            };
        }
        case 'MAP_SET_FILTER_TAB': {
            const { value } = action.payload;

            return {
                ...state,
                filterTab: value,
            };
        }
        case 'MAP_SET_TRANSPORT_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                transportItems: items.map((value) => {
                    return {
                        ...value,
                        conditions:
                            value.conditions.length !== 0
                                ? value.conditions.map((currentCondition, index, array) => {
                                      let previousIndex = index--;
                                      let previousCondition = array[previousIndex];

                                      return {
                                          type: 'message',
                                          datetime: moment.utc(currentCondition.datetime).local().format('YYYY-MM-DD HH:mm:ss'),
                                          receive_date: moment.utc(currentCondition.receive_date).local().format('YYYY-MM-DD HH:mm:ss'),
                                          data: currentCondition,
                                          filters: value.filters,
                                          messages: transportGenerateConditionMessages(currentCondition, previousCondition ? previousCondition : undefined),
                                      };
                                  })
                                : [],
                    };
                }),
                transportCheckedItems: items.reduce(function (accumulator, currentValue) {
                    if (state.transportCheckedItems.includes(currentValue.id)) {
                        accumulator.push(currentValue.id);
                    }

                    return accumulator;
                }, []),
            };
        }
        case 'MAP_SET_TRANSPORT_SELECTED_ITEM': {
            const { data } = action.payload;

            if (!data) {
                return {
                    ...state,
                    transportTab: 'condition',
                    transportSelectedItem: null,
                    transportBroadcastSelectedItem: null,
                    transportConditionSelectedItem: null,
                    transportConditionSelectedDatetime: null,
                };
            }

            if (data.id === state.transportSelectedItem?.id) {
                return {
                    ...state,
                    transportSelectedItem: {
                        ...state.transportSelectedItem,
                        fuel_availability_sensor: data.fuel_availability_sensor,
                        drain_sensor: data.drain_sensor,
                        ground_sensor: data.ground_sensor,
                        dun_cover: data.dun_cover,
                    },
                };
            }
            const newState = {
                ...state,
                transportSelectedItem: {
                    ...data,
                    broadcast: {
                        terid: '',
                        events: [],
                        previousEvents: [],
                        previousRecords: [],
                    },
                    tasks: [],
                    conditions: [],
                    conditionOptions: {
                        open: false,
                        visible: false,
                        interval: config.mapTransportTrackInterval[config.mapTransportTrackInterval.length - 1],
                    },
                    parkingPointsOptions: {
                        open: false,
                        visible: false,
                        interval: config.mapTransportTrackInterval[config.mapTransportTrackInterval.length - 1],
                    },
                },
                transportBroadcastSelectedItem: 1,
                transportConditionSelectedItem: data.conditions.length !== 0 ? data.conditions[data.conditions.length - 1] : null,
            };

            if (state.isHistoryOpen && data.conditions.length !== 0) {
                const activeCondition = data.conditions.filter((condition) => moment(condition.datetime).isSameOrBefore(state.historySelectedTime)).at(-1);
                newState.transportConditionSelectedItem = activeCondition;
            }
            return newState;
        }
        case 'MAP_SET_TRANSPORT_SELECTED_DATE': {
            const { value } = action.payload;

            return {
                ...state,
                transportSelectedItem: state.transportSelectedItem
                    ? {
                          ...state.transportSelectedItem,
                          conditions: [],
                          broadcast: {
                              ...state.transportSelectedItem.broadcast,
                              events: [],
                              previousEvents: [],
                              previousRecords: [],
                          },
                      }
                    : state.transportSelectedItem,
                transportBroadcastSelectedItem: 1,
                transportConditionSelectedItem: null,
                transportConditionSelectedDatetime: state.transportConditionSelectedDatetime && moment(state.transportConditionSelectedDatetime).isBetween(moment(value[0]), moment(value[1]), null, '[]') ? state.transportConditionSelectedDatetime : null,
                transportSelectedDate: moment().isSameOrBefore(value[1]) ? [moment(value[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment(value[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')] : [moment(value[0]).format('YYYY-MM-DD HH:mm:ss'), moment(value[1]).format('YYYY-MM-DD HH:mm:ss')],
            };
        }
        case 'MAP_SET_TRANSPORT_FILTER_CHECKED_TYPE': {
            const { value } = action.payload;

            return {
                ...state,
                transportFilterCheckedType: value,
            };
        }
        case 'MAP_SET_TRANSPORT_CHECKED_ITEM_TASK': {
            const { data } = action.payload;

            return {
                ...state,
                transportItems: state.transportItems.map((transportItem) => {
                    if (transportItem.id !== data.transport_id) {
                        return transportItem;
                    }

                    return {
                        ...transportItem,
                        task: data,
                    };
                }),
            };
        }
        case 'MAP_SET_TRANSPORT_CHECKED_ITEM': {
            const { items } = action.payload;

            switch (state.transportFilterCheckedType) {
                case 'filter':
                    return {
                        ...state,
                        transportProcessingCheckedItems: items,
                    };
                case 'all':
                    return {
                        ...state,
                        transportCheckedItems: items,
                    };
            }
        }
        case 'MAP_ADD_TRANSPORT_CHECKED_ITEM': {
            const { id } = action.payload;

            switch (state.transportFilterCheckedType) {
                case 'filter':
                    return {
                        ...state,
                        transportMarkedCheckedItems: state.transportMarkedCheckedItems.filter((checkedId) => checkedId !== id),
                        transportProcessingCheckedItems: [...state.transportProcessingCheckedItems, id],
                    };
                case 'all':
                    return {
                        ...state,
                        transportCheckedItems: [...state.transportCheckedItems, id],
                    };
            }
        }
        case 'MAP_DELETE_TRANSPORT_CHECKED_ITEM': {
            const { id } = action.payload;

            switch (state.transportFilterCheckedType) {
                case 'filter':
                    return {
                        ...state,
                        transportMarkedCheckedItems: [...state.transportMarkedCheckedItems, id],
                        transportProcessingCheckedItems: state.transportProcessingCheckedItems.filter((checkedId) => checkedId !== id),
                    };
                case 'all':
                    return {
                        ...state,
                        transportCheckedItems: state.transportCheckedItems.filter((checkedId) => checkedId !== id),
                    };
            }
        }
        case 'MAP_SET_TRANSPORT_MARKED_CHECKED_ITEM': {
            const { items } = action.payload;

            return {
                ...state,
                transportMarkedCheckedItems: items,
            };
        }
        case 'MAP_SET_TRANSPORT_SORT_SELECTED_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                transportSortSelectedItem: {
                    name: data.name,
                    order: state.transportSortSelectedItem.name !== data.name ? data.order : state.transportSortSelectedItem.order === 'ASC' ? 'DESC' : 'ASC',
                },
            };
        }
        case 'MAP_ADD_TRANSPORT_FILTER_CHECKED_ITEM': {
            const { value } = action.payload;

            return {
                ...state,
                transportFilterCheckedItems: [...state.transportFilterCheckedItems, value],
            };
        }
        case 'MAP_DELETE_TRANSPORT_FILTER_CHECKED_ITEM': {
            const { value } = action.payload;

            return {
                ...state,
                transportFilterCheckedItems: state.transportFilterCheckedItems.filter((transportFilterCheckedItem) => transportFilterCheckedItem !== value),
            };
        }
        case 'MAP_ADD_TRANSPORT_COLUMN_CHECKED_ITEM': {
            const { value } = action.payload;

            return {
                ...state,
                transportColumnCheckedItems: [...state.transportColumnCheckedItems, value],
            };
        }
        case 'MAP_DELETE_TRANSPORT_COLUMN_CHECKED_ITEM':
            // eslint-disable-next-line no-case-declarations
            const { value } = action.payload;

            return {
                ...state,
                transportColumnCheckedItems: state.transportColumnCheckedItems.filter((transportColumnCheckedItem) => transportColumnCheckedItem !== value),
            };
        case 'MAP_SET_TRANSPORT_CONDITION_CHECKED_TYPE': {
            const { value } = action.payload;

            return {
                ...state,
                transportConditionFilterCheckedType: value,
            };
        }
        case 'MAP_SET_TRANSPORT_CONDITION_CHECKED_ITEM': {
            const { items } = action.payload;

            return {
                ...state,
                transportConditionFilterCheckedItems: items,
            };
        }
        case 'MAP_ADD_TRANSPORT_CONDITION_CHECKED_ITEM': {
            const { items } = action.payload;

            return {
                ...state,
                transportConditionFilterCheckedItems: [...state.transportConditionFilterCheckedItems, ...items],
            };
        }
        case 'MAP_DELETE_TRANSPORT_CONDITION_CHECKED_ITEM': {
            const { items } = action.payload;

            return {
                ...state,
                transportConditionFilterCheckedItems: state.transportConditionFilterCheckedItems.reduce((acc, item) => {
                    if (!items.includes(item)) {
                        acc.push(item);
                    }
                    return acc;
                }, []),
            };
        }
        case 'MAP_SET_TRANSPORT_SEARCH_VALUE': {
            const { value } = action.payload;

            return {
                ...state,
                transportSearchValue: value,
            };
        }
        case 'MAP_SET_TRANSPORT_ITEMS_ACTIVITY': {
            const { data } = action.payload;

            return {
                ...state,
                transportItems: state.transportItems.map((transportItem) => {
                    if (transportItem.id !== data.transport_id) {
                        return transportItem;
                    }

                    return {
                        ...transportItem,
                        last_activity_date: moment.utc(data.last_activity_date).local().format('YYYY-MM-DD HH:mm:ss'),
                    };
                }),
                transportSelectedItem: state.transportSelectedItem
                    ? {
                          ...state.transportSelectedItem,
                          last_activity_date: moment.utc(data.last_activity_date).local().format('YYYY-MM-DD HH:mm:ss'),
                      }
                    : null,
            };
        }
        case 'MAP_ADD_TRANSPORT_ITEMS_CONDITION': {
            const {
                data: { filters = [], ...data },
            } = action.payload;

            return {
                ...state,
                transportItems: state.transportItems.map((transportItem) => {
                    if (transportItem.id !== data.transport_id) {
                        return transportItem;
                    }

                    return {
                        ...transportItem,
                        conditions:
                            transportItem.conditions.length !== 0
                                ? moment
                                      .utc(data.datetime)
                                      .local()
                                      .isAfter(transportItem.conditions[transportItem.conditions.length - 1].datetime)
                                    ? [
                                          transportItem.conditions[transportItem.conditions.length - 1],
                                          {
                                              type: 'message',
                                              datetime: moment.utc(data.datetime).local().format('YYYY-MM-DD HH:mm:ss'),
                                              receive_date: moment.utc(data.receive_date).local().format('YYYY-MM-DD HH:mm:ss'),
                                              data: data,
                                              filters: filters,
                                              messages: transportGenerateConditionMessages(data, transportItem.conditions[transportItem.conditions.length - 1]?.data),
                                          },
                                      ]
                                    : transportItem.conditions
                                : [
                                      {
                                          type: 'message',
                                          datetime: moment.utc(data.datetime).local().format('YYYY-MM-DD HH:mm:ss'),
                                          receive_date: moment.utc(data.receive_date).local().format('YYYY-MM-DD HH:mm:ss'),
                                          data: data,
                                          filters: filters,
                                          messages: transportGenerateConditionMessages(data),
                                      },
                                  ],
                    };
                }),
                transportSelectedItem: state.transportSelectedItem
                    ? state.transportSelectedItem.id !== data.transport_id
                        ? state.transportSelectedItem
                        : moment(state.transportSelectedDate[1]).isSameOrAfter(moment.utc(data.datetime).local(), 'day')
                          ? {
                                ...state.transportSelectedItem,
                                conditions:
                                    state.transportSelectedItem.conditions.length !== 0
                                        ? state.transportSelectedItem.conditions.findIndex((condition) => moment(condition.datetime).isSame(moment.utc(data.datetime).local())) !== -1
                                            ? state.transportSelectedItem.conditions
                                            : [
                                                  ...state.transportSelectedItem.conditions,
                                                  {
                                                      type: 'message',
                                                      datetime: moment.utc(data.datetime).local().format('YYYY-MM-DD HH:mm:ss'),
                                                      receive_date: moment.utc(data.receive_date).local().format('YYYY-MM-DD HH:mm:ss'),
                                                      data: data,
                                                      messages: transportGenerateConditionMessages(data, state.transportSelectedItem.conditions.filter((condition) => condition.type === 'message').pop()?.data),
                                                  },
                                              ].sort((a, b) => moment(a.datetime).toDate() - moment(b.datetime).toDate())
                                        : state.transportSelectedItem.conditions,
                            }
                          : state.transportSelectedItem
                    : null,
                transportConditionSelectedItem: state.transportSelectedItem
                    ? state.transportSelectedItem.id !== data.transport_id
                        ? state.transportConditionSelectedItem
                        : moment(state.transportSelectedDate[1]).isSameOrAfter(moment.utc(data.datetime).local(), 'day')
                          ? state.transportSelectedItem.conditions.length !== 0
                              ? state.transportConditionSelectedItem && moment(state.transportConditionSelectedItem.datetime).isSame(state.transportSelectedItem.conditions.filter((condition) => condition.type === 'message').pop()?.datetime)
                                  ? moment
                                        .utc(data.datetime)
                                        .local()
                                        .isAfter(state.transportSelectedItem.conditions.filter((condition) => condition.type === 'message').pop()?.datetime)
                                      ? {
                                            type: 'message',
                                            datetime: moment.utc(data.datetime).local().format('YYYY-MM-DD HH:mm:ss'),
                                            receive_date: moment.utc(data.receive_date).local().format('YYYY-MM-DD HH:mm:ss'),
                                            data: data,
                                            hdopData: null,
                                            messages: transportGenerateConditionMessages(data, state.transportSelectedItem.conditions.filter((condition) => condition.type === 'message').pop()?.data),
                                        }
                                      : state.transportConditionSelectedItem
                                  : state.transportConditionSelectedItem
                              : null
                          : state.transportConditionSelectedItem
                    : null,
            };
        }
        case 'MAP_ADD_TRANSPORT_ITEMS_COMMAND': {
            const { data } = action.payload;
            const { transportSelectedItem, transportSelectedDate } = state;

            // Если нет выбранного элемента - выход
            if (!transportSelectedItem) return { ...state };

            // Проверка ID транспорта
            const transportId = Number(data.transport_id);
            if (transportSelectedItem.id !== transportId) return { ...state };

            // Проверка на вхождение в диапазон
            const commandDate = parseDate(data.datetime);
            const rangeStart = parseDate(transportSelectedDate[0]);
            const rangeEnd = parseDate(transportSelectedDate[1]);
            if (!commandDate.isValid() || !rangeStart.isValid() || !rangeEnd.isValid()) {
                return state;
            }
            if (!isInRange(commandDate, rangeStart, rangeEnd)) {
                return state;
            }

            // Проверка существующей команды
            const hasExistingCommand = transportSelectedItem.conditions.some((c) => c.datetime === commandDate.format('YYYY-MM-DD HH:mm:ss'));

            if (hasExistingCommand) return { ...state };

            // Создание новой команды
            const newCommand = {
                type: 'command',
                datetime: commandDate.local().format('YYYY-MM-DD HH:mm:ss'),
                receive_date: moment.utc(data.receive_date).local().format('YYYY-MM-DD HH:mm:ss'),
                data,
                messages: transportGenerateConditionMessages(data),
            };

            return {
                ...state,
                transportSelectedItem: {
                    ...transportSelectedItem,
                    conditions: [...transportSelectedItem.conditions, newCommand].sort((a, b) => parseDate(a.datetime) - parseDate(b.datetime)),
                },
            };
        }
        case 'MAP_SET_TRANSPORT_SELECTED_ITEM_CONDITIONS': {
            const { items } = action.payload;
            if (state.transportSelectedItem?.id !== items.at(0)?.transport_id) {
                return {
                    ...state,
                };
            }
            const newState = {
                ...state,
                transportSelectedItem: state.transportSelectedItem
                    ? {
                          ...state.transportSelectedItem,
                          conditions:
                              items.length === 0
                                  ? items
                                  : items.map((currentCondition, index, array) => {
                                        let previousIndex = index;
                                        let previousCondition;

                                        while (previousIndex >= 0) {
                                            previousIndex--;

                                            if (array[previousIndex] && !array[previousIndex].hasOwnProperty('cmd_id')) {
                                                previousCondition = array[previousIndex];
                                                break;
                                            }
                                        }

                                        return {
                                            type: currentCondition.hasOwnProperty('cmd_id') ? 'command' : 'message',
                                            datetime: moment.utc(currentCondition.datetime).local().format('YYYY-MM-DD HH:mm:ss'),
                                            receive_date: moment.utc(currentCondition.receive_date).local().format('YYYY-MM-DD HH:mm:ss'),
                                            data: currentCondition,
                                            messages: transportGenerateConditionMessages(currentCondition, previousCondition ? previousCondition : items[0].hasOwnProperty('cmd_id') ? undefined : items[0]),
                                        };
                                    }),
                      }
                    : null,
                transportConditionSelectedItem: state.transportSelectedItem
                    ? items.length !== 0
                        ? items
                              .filter((currentCondition) => !currentCondition.hasOwnProperty('cmd_id'))
                              .map((currentCondition, index, array) => {
                                  let previousIndex = index;
                                  let previousCondition;

                                  while (previousIndex >= 0) {
                                      previousIndex--;

                                      if (array[previousIndex] && !array[previousIndex].hasOwnProperty('cmd_id')) {
                                          previousCondition = array[previousIndex];
                                          break;
                                      }
                                  }

                                  return {
                                      type: currentCondition.hasOwnProperty('cmd_id') ? 'command' : 'message',
                                      datetime: moment.utc(currentCondition.datetime).local().format('YYYY-MM-DD HH:mm:ss'),
                                      receive_date: moment.utc(currentCondition.receive_date).local().format('YYYY-MM-DD HH:mm:ss'),
                                      data: currentCondition,
                                      hdopData: null,
                                      messages: transportGenerateConditionMessages(currentCondition, previousCondition ? previousCondition : items[0].hasOwnProperty('cmd_id') ? undefined : items[0]),
                                  };
                              })
                              .pop()
                        : null
                    : null,
            };

            if (state.isHistoryOpen && items.length !== 0) {
                const activeCondition = items
                    .filter((currentCondition) => !currentCondition.hasOwnProperty('cmd_id'))
                    .filter((condition) => moment.utc(condition.datetime).local().isSameOrBefore(state.historySelectedTime))
                    .at(-1);
                newState.transportConditionSelectedItem = {
                    ...activeCondition,
                    type: activeCondition.hasOwnProperty('cmd_id') ? 'command' : 'message',
                    datetime: moment.utc(activeCondition.datetime).local().format('YYYY-MM-DD HH:mm:ss'),
                    receive_date: moment.utc(activeCondition.receive_date).local().format('YYYY-MM-DD HH:mm:ss'),
                    data: activeCondition,
                    hdopData: null,
                    messages: transportGenerateConditionMessages(activeCondition, items[0].hasOwnProperty('cmd_id') ? undefined : items[0]),
                };
            }
            return newState;
        }
        case 'MAP_SET_TRANSPORT_CONDITION_SELECTED_DATETIME': {
            const { datetime } = action.payload;

            return {
                ...state,
                transportConditionSelectedDatetime: datetime,
            };
        }
        case 'MAP_SET_TRANSPORT_BROADCAST_SELECTED_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                transportBroadcastSelectedItem: data,
            };
        }
        case 'MAP_SET_TRANSPORT_SELECTED_ITEM_BROADCAST': {
            const { data } = action.payload;

            return {
                ...state,
                transportSelectedItem: state.transportSelectedItem
                    ? {
                          ...state.transportSelectedItem,
                          broadcast: data
                              ? {
                                    ...data,
                                    previousEvents: [],
                                    previousRecords: [],
                                }
                              : state.transportSelectedItem.broadcast,
                      }
                    : null,
            };
        }
        case 'MAP_SET_TRANSPORT_BROADCAST_RECORDS': {
            const { terid, events, records } = action.payload;

            return {
                ...state,
                transportSelectedItem: state.transportSelectedItem
                    ? state.transportSelectedItem.broadcast.terid === terid
                        ? {
                              ...state.transportSelectedItem,
                              broadcast: {
                                  ...state.transportSelectedItem.broadcast,
                                  previousEvents: events,
                                  previousRecords: records,
                              },
                          }
                        : state.transportSelectedItem
                    : null,
            };
        }
        case 'MAP_SET_TRANSPORT_CONDITION_SELECTED_ITEM': {
            const { data } = action.payload;
            const newState = {
                ...state,
                transportTab: state.transportTab !== 'event' ? state.transportTab : 'condition',
                transportConditionSelectedItem: data,
                transportConditionSelectedDatetime: state.transportConditionSelectedDatetime ? state.transportConditionSelectedDatetime : null,
            };

            if (state.isHistoryOpen) {
                newState.historySelectedTime = data.datetime;
            }

            return newState;
        }
        case 'MAP_SET_TRANSPORT_SELECTED_ITEM_CONDITION_OPTIONS': {
            const { data } = action.payload;

            return {
                ...state,
                transportSelectedItem: {
                    ...state.transportSelectedItem,
                    conditionOptions: data,
                },
            };
        }
        case 'MAP_SET_TRANSPORT_SELECTED_ITEM_PARKING_POINTS_OPTIONS': {
            const { data } = action.payload;

            return {
                ...state,
                transportSelectedItem: {
                    ...state.transportSelectedItem,
                    parkingPointsOptions: data,
                },
            };
        }
        case 'MAP_SET_GEOFENCE_SEARCH_VALUE': {
            const { value } = action.payload;

            return {
                ...state,
                geofenceSearchValue: value,
            };
        }
        case 'MAP_ADD_GEOFENCE': {
            const { data } = action.payload;

            return {
                ...state,
                geofenceItems: [...state.geofenceItems, data],
                geofenceGroupItems: state.geofenceGroupItems.map((item) => {
                    if (item.id !== data.group_id) {
                        return item;
                    }

                    return {
                        ...item,
                        geofences: [
                            ...item.geofences,
                            {
                                id: data.id,
                                name: data.name,
                                latitude: data.latitude,
                                longitude: data.longitude,
                            },
                        ].sort((a, b) => a.name.localeCompare(b.name, { sensitivity: 'base' })),
                    };
                }),
            };
        }
        case 'MAP_UPDATE_GEOFENCE': {
            const { id, data } = action.payload;

            return {
                ...state,
                geofenceItems: state.geofenceItems.map((geofenceItem) => {
                    if (geofenceItem.id !== id) {
                        return geofenceItem;
                    }

                    return {
                        ...geofenceItem,
                        ...data,
                    };
                }),
            };
        }
        case 'GEOFENCE_GROUP_UPDATE_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                geofenceItems: state.geofenceItems.map((geofenceItem) => {
                    if (geofenceItem.group_id !== data.id) {
                        return geofenceItem;
                    }

                    return {
                        ...geofenceItem,
                        color: data.color,
                    };
                }),
            };
        }
        case 'MAP_DELETE_GEOFENCE': {
            const { id } = action.payload;

            return {
                ...state,
                geofenceItems: state.geofenceItems.filter((geofenceItem) => geofenceItem.id !== id),
            };
        }
        case 'MAP_SET_GEOFENCE_UPDATED_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                geofenceUpdatedItem: data,
                geofenceUpdatedMode: data ? (data.hasOwnProperty('leafletId') ? 'create' : data.hasOwnProperty('delete') ? 'delete' : 'update') : state.geofenceUpdatedMode,
            };
        }
        case 'MAP_SET_GEOFENCE_CHANGED_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                geofenceChangedItem: data,
            };
        }
        case 'MAP_SET_GEOFENCE_CHECKED_ID': {
            const { items } = action.payload;

            return {
                ...state,
                geofenceCheckedId: items,
            };
        }
        case 'MAP_ADD_GEOFENCES_CHECKED_ID': {
            const { items } = action.payload;

            return {
                ...state,
                geofenceCheckedId: [...state.geofenceCheckedId, ...items],
            };
        }
        case 'MAP_ADD_GEOFENCE_CHECKED_ID': {
            const { id } = action.payload;

            return {
                ...state,
                geofenceCheckedId: [...state.geofenceCheckedId, id],
            };
        }
        case 'MAP_DELETE_GEOFENCE_CHECKED_ID': {
            const { id } = action.payload;

            return {
                ...state,
                geofenceCheckedId: state.geofenceCheckedId.filter((checkedId) => checkedId !== id),
            };
        }
        case 'MAP_SET_GEOFENCE_GROUP_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                geofenceGroupItems: items,
                geofenceItems: items.reduce((accumulator, currentValue) => {
                    return [...accumulator, ...currentValue.geofences];
                }, []),
            };
        }
        case 'MAP_SET_TASK': {
            const { data } = action.payload;

            return {
                ...state,
                taskItems: [...state.taskItems, ...data],
            };
        }
        case 'MAP_SET_TASK_SEARCH_VALUE': {
            const { value } = action.payload;

            return {
                ...state,
                taskSearchValue: value,
            };
        }
        case 'MAP_SET_TASK_SORT_SELECTED_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                taskSortSelectedItem: {
                    name: data.name,
                    order: state.taskSortSelectedItem.name !== data.name ? data.order : state.taskSortSelectedItem.order === 'ASC' ? 'DESC' : 'ASC',
                },
            };
        }
        case 'MAP_ADD_TASK_FILTER_CHECKED_ITEM': {
            const { value } = action.payload;

            return {
                ...state,
                taskFilterCheckedItems: [...state.taskFilterCheckedItems, value],
            };
        }
        case 'MAP_DELETE_TASK_FILTER_CHECKED_ITEM': {
            const { value } = action.payload;

            return {
                ...state,
                taskFilterCheckedItems: state.taskFilterCheckedItems.filter((taskFilterCheckedItem) => taskFilterCheckedItem !== value),
            };
        }
        case 'MAP_ADD_TASK_COLUMN_CHECKED_ITEM': {
            const { value } = action.payload;

            return {
                ...state,
                taskColumnCheckedItems: [...state.taskColumnCheckedItems, value],
            };
        }
        case 'MAP_DELETE_TASK_COLUMN_CHECKED_ITEM': {
            const { value } = action.payload;

            return {
                ...state,
                taskColumnCheckedItems: state.taskColumnCheckedItems.filter((taskColumnCheckedItem) => taskColumnCheckedItem !== value),
            };
        }
        case 'MAP_SET_TASK_SELECTED_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                taskSelectedItem: data,
            };
        }
        case 'SESSION_SET_DATA': {
            const { session } = action.payload;

            if (!session) {
                return {
                    ...state,
                };
            }

            return {
                ...state,
                transportSortSelectedItem: session.permissions.includes('activity')
                    ? {
                          name: config.mapTransportColumns[7].name,
                          order: 'DESC',
                      }
                    : state.transportSortSelectedItem,
                transportFilterCheckedItems: session.permissions.includes('activity') ? config.mapTransportFilters.map((filter) => filter.name) : state.transportFilterCheckedItems,
                transportColumnCheckedItems: session.permissions.includes('activity') ? config.mapTransportColumns.map((column) => column.name) : state.transportColumnCheckedItems,
            };
        }
        case 'MAP_SET_TRANSPORT_CONDITION_HDOP': {
            const { value } = action.payload;

            if (state.transportSelectedItem?.id !== value?.transport_id) {
                return {
                    ...state,
                };
            }

            return {
                ...state,
                transportConditionSelectedItem: !state.transportConditionSelectedItem
                    ? state.transportConditionSelectedItem
                    : state.transportConditionSelectedItem.datetime !== value.datetime
                      ? state.transportConditionSelectedItem
                      : {
                            ...state.transportConditionSelectedItem,
                            hdopData: value,
                        },
            };
        }
        case 'MAP_SET_TRANSPORT_SELECTED_ITEM_TASK': {
            const { value } = action.payload;

            if (state.transportSelectedItem?.id !== value?.transport_id) {
                return {
                    ...state,
                };
            }

            return {
                ...state,
                transportSelectedItem: {
                    ...state.transportSelectedItem,
                    tasks: value?.ttn_task || [],
                },
            };
        }
        default:
            return state;
    }
}

function transportGenerateConditionMessages(condition, previousCondition = undefined) {
    const messages = [];

    if (condition.hasOwnProperty('cmd_id')) {
        config.compareEvents['command'].forEach(function (event) {
            if (event.key === condition.name) {
                messages.push({
                    name: 'command',
                    key: event.key,
                    body: event.message,
                });
            }

            if (event.key.includes('9999') && condition.name.includes(event.key)) {
                messages.push({
                    name: 'command',
                    key: event.key,
                    body: event.message.concat(': ').concat(
                        condition.name
                            .split(',9999,')[1]
                            .split(',')
                            .map(Number)
                            .map((ns, key) => (ns === 0 ? key + 1 : null))
                            .filter((x) => x !== null)
                    ),
                });
            }
        });

        return messages;
    }

    Object.entries(condition).forEach(function ([name, value]) {
        if (config.compareEvents.hasOwnProperty(name)) {
            config.compareEvents[name].forEach(function (event) {
                if (event.compare[0](value)) {
                    if (previousCondition === undefined) {
                        if (name === 'geofence_id') {
                            return;
                        }
                    }

                    if (previousCondition === undefined || event.compare[1](value, previousCondition[name])) {
                        messages.push({
                            name: name,
                            key: event.key,
                            body: event.message,
                            value: value,
                        });

                        if (name === 'geofence_id') {
                            messages[messages.length - 1].value = value !== 0 ? condition.geofence_name : previousCondition ? previousCondition.geofence_name : 0;
                        }
                    }
                }
            });
        }
    });

    return messages;
}

export function transportLoad() {
    return async function transportLoadThunk(dispatch) {
        const { data } = await http.get('/map/transport');
        return dispatch(actions.setTransportItems(data));
    };
}

export function transportBroadcastLoad(id) {
    return async function transportBroadcastLoadThunk(dispatch, getState) {
        const [from, to] = getState().map.transportSelectedDate;

        const { data } = await http.get(`/map/transport/${id}/broadcast?from=${from}&to=${to}&timezone=${getState().session.timezone}`);
        return dispatch(actions.setTransportSelectedItemBroadcast(data));
    };
}

export function transportBroadcastRecordLoad(terid) {
    return async function transportBroadcastRecordLoadThunk(dispatch, getState) {
        const from = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
        const to = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');

        const { data } = await http.get(`/map/transport/${terid}/broadcast/record?from=${from}&to=${to}&timezone=${getState().session.timezone}`);
        return dispatch(actions.setTransportBroadcastRecords(terid, data.events, data.records));
    };
}

export function transportConditionLoad(id) {
    return async function transportConditionLoadThunk(dispatch, getState) {
        const [from, to] = getState().map.transportSelectedDate;
        const { data } = await http.get(`/map/transport/${id}/condition?from=${from}&to=${to}&timezone=${getState().session.timezone}`);
        return dispatch(actions.setTransportSelectedItemConditions(data));
    };
}

export function transportHistoryTracksItemsLoad() {
    return async function transportConditionLoadListThunk(dispatch, getState) {
        let { transportSelectedDate, transportCheckedItems, transportSelectedItem } = getState().map;

        const [from, to] = transportSelectedDate;
        const timezone = getState().session.timezone;
        let list = transportCheckedItems || [];

        if (!list.length && transportSelectedItem) {
            list.push(transportSelectedItem.id);
        }
        if (!list.length) {
            return;
        }
        const results = await http.get(`/map/transport/conditions?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}&timezone=${timezone}&list=${list}`);
        if (results.data) {
            return dispatch(actions.setTransportHistoryTracksItems(results.data));
        }
    };
}

export function transportTaskLoad(id) {
    return async function transportTaskLoadThunk(dispatch) {
        const { data } = await http.get(`/map/transport/${id}/task`);
        return dispatch(actions.setTransportCheckedItemTask(data));
    };
}

export function transportCommandSend(id, name) {
    return async function transportCommandSendThunk(dispatch) {
        const { data } = await http.post(`/map/transport/${id}/command`, { name });

        config.compareEvents['command'].forEach((event) => {
            if (event.key === data.body) {
                return dispatch(
                    notificationActions.addQueue({
                        text: config.mapTransportCommandMessages[data.code].replace('$name', event.message),
                    })
                );
            }
        });
    };
}

export function geofenceGroupLoad() {
    return async function geofenceGroupLoadThunk(dispatch) {
        const { data } = await http.get('/map/geofence?type=group');
        return dispatch(actions.setGeofenceGroupItems(data));
    };
}

export function geofenceCreate(params) {
    return async function geofenceCreateThunk(dispatch) {
        const { data } = await http.post('/map/geofence', params);
        return dispatch(actions.addGeofence(data));
    };
}

export function geofenceUpdate(id, params) {
    return async function geofenceUpdateThunk(dispatch) {
        const { data } = await http.put(`/map/geofence/${id}`, params);
        return dispatch(actions.updateGeofence(id, data));
    };
}

export function geofenceOptionsUpdate(id, params) {
    return async function geofenceOptionsUpdateThunk(dispatch) {
        const { data } = await http.put(`/map/geofence/${id}/options`, params);
        return dispatch(actions.updateGeofence(id, data));
    };
}

export function geofenceDelete(id) {
    return async function geofenceDeleteThunk(dispatch) {
        await http.delete(`/map/geofence/${id}`);
        return dispatch(actions.deleteGeofence(id));
    };
}

export function taskLoad() {
    return async function taskLoadThunk(dispatch) {
        const { data } = await http.get('/map/task');
        return dispatch(actions.setTask(data));
    };
}

export function hdopLoad(params) {
    return async function hdopLoadThunk(dispatch, getState) {
        const id = getState().map.transportSelectedItem.id;
        const dt = moment(params.datetime).format('YYYY-MM-DD HH:mm:ss');
        const timezone = getState().session.timezone;

        const { data } = await http.get(`/map/transport/${id}/hdop?datetime=${dt}&parking_time=${params.parking_time}&timezone=${timezone}`);
        return dispatch(
            actions.setConditionHdop({
                ...data,
                datetime: params.datetime,
                transport_id: id,
                parking_time: params.parking_time,
            })
        );
    };
}

export function transportTaskInfoLoad(id) {
    return async function transportTaskInfoLoadThunk(dispatch) {
        const { data } = await http.get(`/map/transport/${id}/task`);
        return dispatch(actions.setTransportSelectedItemTask(data));
    };
}

const parseDate = (str) => moment.utc(str);
const isInRange = (commandDate, rangeStart, rangeEnd) => {
    return commandDate.isBetween(rangeStart, rangeEnd, null, '[]');
};
